module.exports = __webpack_public_path__ + "img/header-blob-dark.cd0fe138.svg";